import { CircularProgress } from '@material-ui/core';
import React from 'react';
import { TournamentAwardDetailComponent } from './';
import { IComponentProps } from './TournamentAwardDetailContainer.connector';

export class TournamentAwardDetailContainer extends React.Component<IComponentProps> {
  public componentDidMount() {
    const { tournamentId, fetchTournamentAwards } = this.props;
    fetchTournamentAwards({ 'tournament.id': tournamentId });
  }

  public render() {
    const { award, fetching } = this.props;

    if (fetching) {
      return <CircularProgress size={100} style={{ width: 100, margin: 'auto' }} />;
    }

    return <TournamentAwardDetailComponent award={award} />;
  }
}
